import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { translate } from '@/services/TranslationService';
import store from '@/services/store';
import { toast } from '@/components/ui/use-toast';
import NOVOLOADER from '@/shared/components/NOVOLoader';

const parseMessageData = (data) => {
  if (!data) return null;

  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }

  if (typeof data === 'object') {
    return data;
  }

  return null;
};

const ActiveSelectedApplication = ({
  activeApplication,
  metadata,
  onResetActiveApplication,
  onApplicationSubmitted,
}) => {
  const { url, name } = activeApplication;
  const token = store.getState().authReducer.auth_token;
  const iframeRef = useRef(null);

  const secureUrl = useMemo(() => {
    const formUrl = new URL(url);

    if (token) {
      formUrl.searchParams.set('Token', token);
    }

    if (metadata?.applicationsLicensePlate) {
      formUrl.searchParams.set(
        'license_plate',
        metadata.applicationsLicensePlate
      );
    }

    if (metadata?.applicationsCode) {
      formUrl.searchParams.set('code', metadata.applicationsCode);
    }

    return formUrl.toString();
  }, [
    metadata?.applicationsCode,
    metadata?.applicationsLicensePlate,
    token,
    url,
  ]);
  const urlOrigin = new URL(url).origin;

  const [isIframeLoaded, setIsIframeLoaded] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handleMessage = (event) => {
      if (event.source !== iframeRef.current?.contentWindow) return;
      if (event.origin !== urlOrigin) return;

      const payload = parseMessageData(event.data);
      if (!payload || typeof payload !== 'object') return;

      console.log('Application form postMessage payload:', payload);

      const hasApiCode =
        payload.code !== null &&
        payload.code !== undefined &&
        payload.code !== '';
      const apiTranslationKey = hasApiCode ? `api_${payload.code}` : null;
      const translatedMessage = apiTranslationKey
        ? translate(apiTranslationKey, payload)
        : null;

      if (payload.error === false) {
        toast({
          variant: 'success',
          title:
            translatedMessage && translatedMessage !== apiTranslationKey
              ? translatedMessage
              : translate('OTHER.success'),
        });

        onApplicationSubmitted();
        return;
      }

      if (!payload.error) return;

      toast({
        variant: 'destructive',
        title:
          translatedMessage && translatedMessage !== apiTranslationKey
            ? translatedMessage
            : payload.result ||
              payload.user_description ||
              translate('publicFormApplication.submitError'),
      });

      onResetActiveApplication();
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [onApplicationSubmitted, onResetActiveApplication, urlOrigin]);

  return (
    <div className="w-full h-full flex flex-col relative">
      <div className="flex flex-row justify-start items-center w-full p-4">
        <ArrowLeft
          className="cursor-pointer"
          onClick={onResetActiveApplication}
        />
      </div>
      {isIframeLoaded && <NOVOLOADER />}
      <iframe
        ref={iframeRef}
        title={name}
        src={secureUrl}
        className="flex-1"
        // loading="lazy"
        onLoad={() => {
          setIsIframeLoaded(false);
        }}
      />
    </div>
  );
};

export default ActiveSelectedApplication;
